import Header from "../../components/layout/Header/Header";
import Layout from "../../components/layout/Layout/Layout";
import ImporterDetails from "../../components/global/Importers/ImporterDetails";
import BaseWineSearchBar from "../../components/global/SearchBar/BaseWineSearchBar";
import React from "react";

export default function ImportersPage() {
  return (
    <Layout>
      <Header/>
      <BaseWineSearchBar
        className="pb-8"
        hideResults={true}
      />
      <ImporterDetails />
    </Layout>
  );
}